module.exports = __webpack_public_path__ + "static/media/dinosaur(1).fcf3c68c.PNG";